import { render, staticRenderFns } from "./UsersSkeleton.vue?vue&type=template&id=47133c44&scoped=true&"
import script from "./UsersSkeleton.vue?vue&type=script&lang=ts&"
export * from "./UsersSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47133c44",
  null
  
)

export default component.exports